import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import { api, setToken, getToken } from "../lib/api";
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const settled = useRef(false);
  useEffect(() => {
    if (!getToken()) { setUser(false); setLoading(false); return; }
    api.get("/auth/me").then((u) => { if (!settled.current) setUser(u); })
      .catch(() => { if (!settled.current) { setToken(null); setUser(false); } })
      .finally(() => setLoading(false));
  }, []);
  const login = async (email, password) => {
    const data = await api.post("/auth/login", { email, password });
    settled.current = true; setToken(data.token); setUser(data.user); return data.user;
  };
  const logout = async () => { try { await api.post("/auth/logout"); } catch (e) {} setToken(null); setUser(false); };
  const refreshUser = async () => { const u = await api.get("/auth/me"); setUser(u); return u; };
  const can = (m, a) => { if (!user) return false; if (user.is_admin) return true; return ((user.permissions || {})[m] || []).includes(a); };
  return <AuthContext.Provider value={{ user, loading, login, logout, refreshUser, can }}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
